{
  "brand": {
    "name": "Færdo"
  },
  "landing": {
    "description": "Færd to po duńsku podróż.",
    "tagline": "Zacznij swoją podróż już teraz."
  },
  "locale": {
    "switchLabel": "Język",
    "en": "English",
    "pl": "Polski"
  },
  "consent": {
    "message": "Używamy analitycznych plików cookie, aby rozumieć, jak korzystasz z tej strony i ją ulepszać. Możesz zaakceptować lub odrzucić.",
    "accept": "Akceptuj",
    "decline": "Odrzuć"
  }
}
